module.exports = __webpack_public_path__ + "static/media/gift05_en.f1bc070e.png";